import { connect } from 'react-redux';

import { IReduxState, TThunkDispatch } from '../../types/redux';
import { dealTypeFromJsonQuery, FDealType } from '../../utils/category';
import { setDealType } from '../../actions/filters';
import { FiltersTabs, IFiltersTabProps, IFiltersTabsProps } from '../../components/FiltersTabs';
import { DEAL_TYPE_NAMES } from '../../constants/dealType';
import { trackDealTypeTabClick, trackSpecialTabClick } from './tracking';
import { EPageKind } from '../../types/page';
import * as React from 'react';
import { setActiveSpecialTab } from '../../actions/specialTabs';
import { ESpecialTabs } from '../../constants/specialTabs';
import { selectSpecialTabActive } from '../../hooks/selectors/specialTabs';

type TFiltersTabsStateProps = {
  isFindAgentTabEnabled: boolean;
  currentTabActive: FDealType | ESpecialTabs;
  pageKind: EPageKind;
};
type TFilterOfferTypeDispatchProps = {
  onDealTypeSelect(event: React.MouseEvent<HTMLAnchorElement>, dealType: FDealType, pageKind: EPageKind): void;
  onValuationSelect(pageKind: EPageKind): void;
  onSpecialTabSelect(event: React.MouseEvent<HTMLAnchorElement>, tab: ESpecialTabs, pageKind: EPageKind): void;
};

export function mapStateToProps(state: IReduxState): TFiltersTabsStateProps {
  return {
    currentTabActive: selectSpecialTabActive(state) || dealTypeFromJsonQuery(state.filters.jsonQuery),
    pageKind: state.page.kind,
    isFindAgentTabEnabled: state.features.isFindAgentTabEnabled,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onDealTypeSelect: (event: React.MouseEvent<HTMLAnchorElement>, dealType: FDealType, pageKind: EPageKind) => {
      event.preventDefault();
      dispatch(setDealType(dealType));
      dispatch(setActiveSpecialTab(null));
      trackDealTypeTabClick(pageKind, dealType);
    },
    onSpecialTabSelect: (event: React.MouseEvent<HTMLAnchorElement>, tab: ESpecialTabs, pageKind: EPageKind) => {
      event.preventDefault();

      dispatch(setActiveSpecialTab(tab));

      trackSpecialTabClick(pageKind, tab);
    },
    onValuationSelect: (pageKind: EPageKind) => {
      trackSpecialTabClick(pageKind, ESpecialTabs.Valuation);
    },
  };
}

export function mergeProps(
  stateProps: TFiltersTabsStateProps,
  dispatchProps: TFilterOfferTypeDispatchProps,
): IFiltersTabsProps {
  const { currentTabActive, pageKind } = stateProps;
  const { onDealTypeSelect, onValuationSelect, onSpecialTabSelect } = dispatchProps;
  const items: IFiltersTabProps[] = [
    {
      label: DEAL_TYPE_NAMES[FDealType.Sale],
      url: '/kupit/',
      isSelected: currentTabActive === FDealType.Sale,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.Sale, pageKind);
      },
    },
    {
      label: DEAL_TYPE_NAMES[FDealType.RentLongterm],
      url: '/snyat/',
      isSelected: currentTabActive === FDealType.RentLongterm,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.RentLongterm, pageKind);
      },
    },
    {
      label: DEAL_TYPE_NAMES[FDealType.RentDaily],
      url: '/posutochno/',
      isSelected: currentTabActive === FDealType.RentDaily,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onDealTypeSelect(event, FDealType.RentDaily, pageKind);
      },
    },
    {
      label: 'Оценить',
      url: '/kalkulator-nedvizhimosti/',
      isSelected: false,
      clickHandler: () => {
        onValuationSelect(pageKind);
      },
    },
    {
      label: 'Ипотека',
      url: '/mortgage/',
      isSelected: currentTabActive === ESpecialTabs.Mortgage,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onSpecialTabSelect(event, ESpecialTabs.Mortgage, pageKind);
      },
    },
  ];

  if (stateProps.isFindAgentTabEnabled) {
    items.push({
      label: 'Найти риелтора',
      url: '/realtors/',
      isSelected: currentTabActive === ESpecialTabs.SearchRealtors,
      clickHandler: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        onSpecialTabSelect(event, ESpecialTabs.SearchRealtors, pageKind);
      },
    });
  }

  return { items };
}

export const FiltersTabsContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FiltersTabs);
